<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="header-card">
            <mat-card-title>Seguridad - Usuarios &nbsp;&nbsp;
                <button type="button" mat-stroked-button color="primary" (click)="postUser()" *ngIf="viewBtnPermission">
                    Añadir Usuarios
                </button>
            </mat-card-title>
            
            <div class="right-actions">
                <mat-form-field>
                    <mat-label>Filtro</mat-label>
                    <mat-select  [(value)]="selectedValue" (selectionChange)="onFilterChange($event)">
                      <mat-option *ngFor="let state of filterState" [value]="state.value">
                        {{ state.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>

        </div>
        <div class="contenedor">
            <app-users-list-table [users]="users$ | async" (notify)="reciveNotify($event)"></app-users-list-table>
        </div>
    </mat-card-content>
</mat-card>
